import TasksGraphBox from "./TasksGraphBox"
import classes from './Box.module.css'

export default function TasksGraphBoxWrapper({summary}) {
    const charts = [
        {
            id: 1,
            label: 'completed',
            dataValues: [summary.thirty_days_review.total_completed.by_me, summary.thirty_days_review.total_completed.by_others],
            dataLabels: ['By me', 'By others'],
            title: 'Total Completed'
        },
        {
            id: 2,
            label: 'received',
            dataValues: [summary.thirty_days_review.total_received.to_me, summary.thirty_days_review.total_received.to_my_teams],
            // dataValues: [20, 60],
            dataLabels: ['To me', 'To my teams'],
            title: 'Total Received'
        }
    ]

    return <div className={classes.item_body_grid}>
        <div className={classes.charts_container}>
            {charts.map((chart) => (
                <TasksGraphBox key={chart.id} values={chart.dataValues} labels={chart.dataLabels} title={chart.title}/>
                
            ))}
        </div>
    </div>
}